// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"4f22f73f","453":"1f960028"}[chunkId] + ".chunk.js";
};